import {useQuery} from "react-query";
import ajax from "../actions/ajax";

const useComplaintCategoryList = () => {
    const {isLoading, data} = useQuery('complaint_category', () => ajax.get("/complaint_category"));
    return {isLoading, data};
};

export default useComplaintCategoryList;